import {createContext, ReactNode, useEffect, useState} from "react";
import {IconButton, Snackbar} from "@mui/joy";
import {Close} from "@mui/icons-material";
import 'firebase/compat/auth';
import {getErrorMessage} from "./Utils";


export const FeedbackContext = createContext<any>(null);

interface FeedbackProviderProps {
    children?: ReactNode
}

// Bridge globale: permette a codice fuori dai componenti React (es. ViewModel.tsx)
// di mostrare errori nella stessa Snackbar, senza usare window.alert().
let globalSetError: ((err: any) => void) | null = null

export function reportError(err: any) {
    if (globalSetError) globalSetError(err)
    else console.error(err)
}

export function FeedbackProvider(props: FeedbackProviderProps) {
    const [bigloading, setBigLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>("");
    const [errorVisible, setErrorVisible] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        globalSetError = setError
        return () => {
            globalSetError = null
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(error !== undefined && error !== "" && error !== null) {
            setErrorVisible(true)
        }
    }, [error])


    return (
        <FeedbackContext.Provider value={{loading, bigloading, error, message, setLoading, setBigLoading, setError, setMessage}}>
            {props.children}
            <Snackbar
                autoHideDuration={5000}
                open={errorVisible}
                variant="outlined"
                color="danger"
                size="md"
                onClose={() => {
                    setErrorVisible(false)
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                endDecorator={
                    <IconButton
                        onClick={() => {
                            setErrorVisible(false)
                        }}
                        size="sm"
                    >
                        <Close />
                    </IconButton>
                }
            >
                {getErrorMessage(error)}
            </Snackbar>
            <Snackbar
                autoHideDuration={5000}
                open={message !== ""}
                variant="outlined"
                color="primary"
                size="md"
                onClose={() => {
                    setMessage("");
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                endDecorator={
                    <IconButton
                        onClick={() => setMessage("")}
                        size="sm"
                    >
                        <Close />
                    </IconButton>
                }
            >
                {message}
            </Snackbar>
        </FeedbackContext.Provider>
    )
}